import React, { useState, useEffect, memo } from "react";
import { Link, useParams } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
} from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { NEWS_IMAGE_BASE_URL } from "../../../config/apiConfig";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LatestNewsSkeleton from "../skeletons/latestNewsSkeleton/latestNewsSkeleton";
import ImageWithLoader from "../uiUtils/imageWithLoader";

const slidesToShow = 4; // Number of slides to show at a time

const LatestNews = ({
  currentPage,
  setCurrentPage,
  perPage,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
  filter,
  setFilter,
}) => {
  /* ------------ */

  const [events, setEvents] = useState([]);
  const { eventsData, eventsloading, eventsError } = useSelector(
    (state) => state.eventsReducer
  );
  var currentUrl = useLocation().pathname;
  const { user } = useUser();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);

  useEffect(() => {
    const response = eventsData;

    setEvents(response?.data?.result?.list);
  }, [user?.client_profile_company_code, eventsloading]);
  /* ----------------*/

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    const userStat = getUserStatsObject(
      "Dashboard",
      "scroll",
      "Data: Latest News, Page Source: Dashboard",
      currentUrl
    );
    recordActivity(userStat);
    setCurrentIndex(
      (prevIndex) => (prevIndex + 1) % (events.length - slidesToShow + 1)
    );
  };

  const handlePrev = () => {
    const userStat = getUserStatsObject(
      "Dashboard",
      "scroll",
      "Data: Latest News, Page Source: Dashboard",
      currentUrl
    );
    recordActivity(userStat);
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + (events.length - slidesToShow + 1)) %
        (events.length - slidesToShow + 1)
    );
  };
  events?.map((event, event_index) => {
    let companies = event?.tags?.filter((tag_data) => {
      return tag_data.type === "companies";
    });
    companies = companies.reduce((acc, item) => {
      acc[item.key] = item.label;
      return acc;
    }, {});

    let mega_trends = event?.tags?.filter((tag_data) => {
      return tag_data.type === "mega_trends";
    });
    mega_trends = mega_trends.reduce((acc, item) => {
      acc[item.key] = item.label;
      return acc;
    }, {});

    let industry_trends = event?.tags?.filter((tag_data) => {
      return tag_data.type === "industry_trends";
    });
    industry_trends = industry_trends.reduce((acc, item) => {
      acc[item.key] = item.label;
      return acc;
    }, {});

    let news_types = event?.tags?.filter((tag_data) => {
      return tag_data.type === "news_types";
    });
    news_types = news_types.reduce((acc, item) => {
      acc[item.key] = item.label;
      return acc;
    }, {});

    let urlParams = {
      img_index: event_index,
      companies: companies && Object.keys(companies).length ? companies : {},
      industry_trends:
        industry_trends && Object.keys(industry_trends).length
          ? industry_trends
          : {},
      mega_trends:
        mega_trends && Object.keys(mega_trends).length ? mega_trends : {},
      news_types:
        news_types && Object.keys(news_types).length ? news_types : {},
      size: 200,
    };

    let img_base_url = NEWS_IMAGE_BASE_URL;
    let encodedParams = encodeURIComponent(JSON.stringify(urlParams));

    let news_image_src_path = img_base_url + encodedParams;

    event.news_image_src_path = news_image_src_path;

    event.tagged_filtered = event.tags.filter(
      (tag_data) => tag_data.type !== "news_types"
    );
  });

  const handleNewsLinkClick = (news_data) => {
    var news_title = ", News: " + news_data.news_title;

    const userStat = getUserStatsObject(
      "Dashboard News",
      "page_load",
      "Page Source: Dashboard" + news_title,
      currentUrl
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);

    window.open(news_data?.url, "_blank");
  };

  return (
    <>
      {/* { loader === true && (<ScreenLoader />) } */}
      {!eventsloading ? (
        events?.length > 0 ? (
          <div className="latest_news_wrapper">
            <div className="latest_news_block" style={{ float: "right" }}>
              {/* <h5 className="latest_news_head">
              <FeatherIcon.TrendingUp className="trend_up" />
              Latest Market News
            </h5> */}
              <div className="top_slider_btn">
                <button
                  className="carousel__button carousel__button--next"
                  onClick={handleNext}
                >
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </button>
                <button
                  className="carousel__button carousel__button--prev"
                  onClick={handlePrev}
                >
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div className="carousel">
              <div className="slider-wrapper">
                <div
                  className="slider-content"
                  style={{
                    transform: `translateX(-${
                      currentIndex * (100 / slidesToShow)
                    }%)`,
                  }}
                >
                  {events?.map((event, index) => (
                    <div className="slider-item" key={event.id + "_" + index}>
                      <div className="latest_news_tile">
                        <div className="image_block_news">
                          <ImageWithLoader
                            src={event.news_image_src_path}
                            alt={event.news_title}
                            className="slider-image image_block_latestnews"
                          />
                        </div>
                        <div className="latest_news_info">
                          <h5 className="latest_news_head">
                            <Link
                              className="latest_news_head"
                              onClick={() => handleNewsLinkClick(event)}
                              // to={event.url}
                            >
                              {event.news_title}
                            </Link>
                          </h5>
                          <p className="latest_news_time">
                            {event.news_time_before}
                          </p>
                          <ul className="latest_news_tags">
                            {event.tags.slice(0, 2).map((tag, index) => (
                              <li key={index} className="latest_news_taglist">
                                <span className="tags_link">{tag.label}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>No news available publicly</div>
        )
      ) : (
        <LatestNewsSkeleton />
      )}
    </>
  );
};
export default memo(LatestNews);
